import { z } from 'zod';
export const clearableDateSchema = (original) => original.nullish().or(z.literal('').transform(() => undefined));
